import { Strbuf } from '../types';
import { isAry, isBuf, isStr } from '../utils/common';
import { checkUtf16 } from './checkUtf16';
import { getHistoAndBasicAggs } from './getHistoAndBasicAggs';
import { StringBufAggsBasic, StringBufAggsHisto, UTF8_STATUS } from './getHistoAndBasicAggs.types';
import { summarizeHisto } from './getStrbufSummary';
import { DetectedEncoding } from './guessEncodingNoBom.types';

export function checkUtf32(
	aggs: StringBufAggsBasic,
	partialData = false
): false | 'utf32be' | 'utf32le' {
	// Check for UTF-32 (without BOM)
	if (aggs.length >= 4 && (aggs.length % 4 === 0 || partialData)) {
		if (aggs.numNulls > 0.5 * aggs.length) {
			if (aggs.nulls[0] > 2 * aggs.nulls[3] && aggs.nulls[1] > 2 * aggs.nulls[3]) {
				return 'utf32be';
			} else if (aggs.nulls[3] > 2 * aggs.nulls[0] && aggs.nulls[2] > 2 * aggs.nulls[0]) {
				return 'utf32le';
			}
		}
	}

	return false;
}

export function guessEncodingNoBom1(
	aggs: StringBufAggsHisto,
	partialData = false
): DetectedEncoding {
	if (aggs.length === 0) {
		return 'empty';
	}

	if (aggs.numNulls === aggs.length) {
		return 'null';
	}

	{
		const is32 = checkUtf32(aggs, partialData);
		if (is32) {
			return is32;
		}
	}

	{
		const is16 = checkUtf16(aggs, partialData);
		if (is16) {
			return is16;
		}
	}

	const summary = summarizeHisto(aggs.histo);

	if (summary.hasHigh && aggs.numInvalidUtf8Seqs === 0) {
		if (aggs.utf8State === UTF8_STATUS.ACCEPT) {
			// Complete UTF8 with no missing trailing bytes
			return 'utf8';
		} else if (partialData && aggs.utf8State !== UTF8_STATUS.REJECT) {
			// Incomplete UTF8, but valid so far
			return 'utf8';
		}
	}

	if (summary.allAsciiPrintableCrLfNull) {
		return 'ascii';
	}

	if (!summary.hasHigh) {
		return '7bit';
	}

	return '8bit';
}

export function guessEncodingNoBom(
	dataOrAggs: Strbuf | Strbuf[] | StringBufAggsHisto,
	partialData = false
): DetectedEncoding {
	const aggs: StringBufAggsHisto =
		isStr(dataOrAggs) || isBuf(dataOrAggs) || isAry(dataOrAggs)
			? getHistoAndBasicAggs(dataOrAggs)
			: dataOrAggs;
	return guessEncodingNoBom1(aggs, partialData);
}
